import React, { SVGProps } from "react";

const SendTextIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="50"
    height="48"
    viewBox="0 0 57 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_74_2189)">
      <rect x="2" y="1" width="53" height="50" rx="25" fill="white" />
      <rect x="2.5" y="1.5" width="52" height="49" rx="24.5" stroke="#E2E8F0" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0409 15.4321C18.2026 15.2916 18.4023 15.2023 18.6148 15.1753C18.8273 15.1483 19.043 15.1849 19.2347 15.2804L38.7347 25.0304C38.915 25.1203 39.0666 25.2586 39.1726 25.4299C39.2786 25.6012 39.3348 25.7986 39.3348 26C39.3348 26.2015 39.2786 26.3989 39.1726 26.5702C39.0666 26.7414 38.915 26.8798 38.7347 26.9696L19.2347 36.7196C19.043 36.8155 18.8272 36.8524 18.6145 36.8256C18.4019 36.7989 18.202 36.7096 18.0401 36.5691C17.8781 36.4287 17.7615 36.2434 17.705 36.0366C17.6484 35.8299 17.6545 35.611 17.7224 35.4077L20.4979 27.0834H26.3338C26.6211 27.0834 26.8967 26.9692 27.0998 26.7661C27.303 26.5629 27.4171 26.2874 27.4171 26C27.4171 25.7127 27.303 25.4372 27.0998 25.234C26.8967 25.0308 26.6211 24.9167 26.3338 24.9167H20.4979L17.7213 16.5924C17.6538 16.3891 17.648 16.1705 17.7047 15.964C17.7614 15.7575 17.8791 15.5724 18.0409 15.4321Z"
        fill="#0D57DE"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_74_2189"
        x="0"
        y="0"
        width="57"
        height="54"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_74_2189"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_74_2189"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SendTextIcon;
